import { render, staticRenderFns } from "./MistLab.vue?vue&type=template&id=66ba699a&scoped=true"
import script from "./MistLab.vue?vue&type=script&lang=js"
export * from "./MistLab.vue?vue&type=script&lang=js"
import style0 from "./MistLab.vue?vue&type=style&index=0&id=66ba699a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ba699a",
  null
  
)

export default component.exports